<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <b>Seznam návštěv, diagnóz, výkonů a léků</b>
                </div>
                <div class="col-md-6">
                    <div class="input-group">
                        <datepicker v-model="dateFrom" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="dateFrom"></datepicker>
                        <!-- <datepicker v-model="dateTo" placeholder="vybrat datum do" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="dateTo"></datepicker> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="card-header">

        </div>
        <div class="card-body" v-if="visits.length > 0">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="row m-0">
                        <th class="col-sm-3">RČ/ČP / Klient / pojišťovna</th>
                        <th class="col-sm-2">Diagnóza</th>
                        <th class="col-sm-2">Výkon(y)</th>
                        <th class="col-sm-2">ZULP</th>
                        <th class="col-sm-3">Léky</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="row m-0" v-for="visit in visits">
                        <td class="col-sm-3">
                            <i class="fa fa-2x fa-circle-o text-info" aria-hidden="true" v-if="visit.state === 'scheduled'"></i>
                            <i class="fa fa-2x fa-clock-o text-success" aria-hidden="true" v-else-if="visit.state === 'arrived'"></i>
                            <i class="fa fa-2x fa-check-circle text-success" aria-hidden="true" v-else-if="visit.state === 'completed'"></i>
                            <i class="fa fa-2x fa-dot-circle-o text-warning" aria-hidden="true" v-else-if="visit.state === 'elaborated'"></i>
                            <i class="fa fa-2x fa-times-circle-o text-danger" aria-hidden="true" v-else-if="visit.state === 'failed'"></i>
                            <i class="fa fa-2x fa-dot-circle-o text-danger" aria-hidden="true" v-else-if="visit.state === 'excused'"></i>
                            <i class="fa fa-2x fa-times-circle text-danger" aria-hidden="true" v-else-if="visit.state === 'canceled'"></i>
                            <span v-if="visit.client.insurance_number">ČP: <b>{{ visit.client.insurance_number }}</b></span> <span v-else="">RČ: <b>{{ visit.client.p_i_n }}</b></span>
                            <router-link :to="{ name: 'ShowVisit', params: { clientid: visit.client.id, visitid: visit.id }}">
                                <i class="fa fa-arrow-circle-right text-info" aria-hidden="true"></i>
                            </router-link>
                            <br>
                            {{ visit.client.first_name }} {{ visit.client.last_name }}<br>
                                <span class="badge badge-lg badge-secondary badge_health_insurance" v-if="visit.client.health_insurance" :class="'_'+visit.client.health_insurance.code">{{ visit.client.health_insurance.code === '---' ? visit.client.health_insurance.shortcut : visit.client.health_insurance.code}}</span>
                                <span class="badge badge-lg pointer badge-warning badge_health_insurance" role="button" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
                        </td>
                        <td class="col-sm-6 p-0" v-if="visit.diagnosis.length > 0">
                            <table class="table table-bordered m-0">
                                <tr v-for="d in visit.diagnosis" class="row m-0">
                                    <td class="col-sm-4">{{ d.disease.code }} - {{ d.disease.name_cs }}</td>
                                    <td class="col-sm-8 p-0" v-if="d.actions.length > 0">
                                        <table class="table table-bordered m-0">
                                            <tr v-for="a in d.actions" class="row m-0">
                                                <td class="col-sm-6">
                                                    {{ a.operation.code }}  - {{ a.operation.name }}
                                                </td>
                                                <td class="col-sm-6 p-0" v-if="a.zulp.length > 0">
                                                    <table class="table table-bordered m-0">
                                                        <tr v-for="z in a.zulp" class="">
                                                            <td class="">
                                                                {{ z.amount }}x {{ z.medicine.label }}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="col-sm-8" v-else="">
                                        <span class="text-danger font-weight-bold">
                                            DIAGNÓZA NEMÁ PŘIŘAZENÉ VÝKONY
                                            <i class="fa fa-close fa-2x text-danger"></i>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td class="col-sm-6" v-else="">
                            <span class="text-danger">
                                U NÁVŠTĚVY NENÍ DIAGNÓZA
                                <i class="fa fa-close fa-2x text-danger"></i>
                            </span>
                        </td>
                        <td class="col-sm-3 p-0" v-if="visit.medicament.length > 0">
                            <table class="table table-bordered m-0">
                                <tr v-for="m in visit.medicament" class="m-0">
                                    <td>{{ m.amount }}x {{ m.medicine ? m.medicine.label : '' }} {{ m.individual_medicine ? m.individual_medicine.name : '' }} {{ m.paid_by_sick === true ? ' - hradí nemocný' : '' }}</td>
                                </tr>
                            </table>
                        </td>
                        <td class="col-sm-3" v-else="">
                            U návštěvy nebyl předepsán lék
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-else-if="visitsPending">
            <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                    (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (na tento den není nic naplánováno)
            </div>
        </div>
    </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        getParams: {
          date_from: '',
          date_to: ''
        },
        visits: false,
        visitsPending: false,
        visitsError: false,
        dateFrom: '',
        dateTo: ''
      }
    },
    mixins: [apiMixin],
    methods: {
      loadVisitsReportong () {
        this.visits = []
        this.getVisitsReporting(this.getParams)
      }
    },
    components: {
      Datepicker
    },
    beforeMount () {
      this.loadVisitsReportong()
    },
    watch: {
      dateFrom (date) {
        this.getParams.date_from = this.$moment(date).format('DD.MM.YYYY')
        this.getParams.date_to = this.$moment(date).format('DD.MM.YYYY')
        this.loadVisitsReportong()
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    /* .table th, .table td {
        padding: 1px;
    }*/

    .table > tbody > tr > td > table > tr:last-child  td {
        border-bottom: none;
    }

    .table > tbody > tr > td > table > tr:first-child td {
        border-top: none;
    }

    .btn_extra_small {
        line-height: 1;
        padding: 0.1rem;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Reporting/components/ReportingList.vue?3a20541f